import(/* webpackMode: "eager" */ "/home/runner/work/vhire/vhire/v4-frontend/src/app/(app)/error.tsx");
